import { render, staticRenderFns } from "./ShowofforumCommunity.vue?vue&type=template&id=a251c944&scoped=true&"
import script from "./ShowofforumCommunity.vue?vue&type=script&lang=js&"
export * from "./ShowofforumCommunity.vue?vue&type=script&lang=js&"
import style0 from "./ShowofforumCommunity.vue?vue&type=style&index=0&id=a251c944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a251c944",
  null
  
)

export default component.exports